import { createClient } from "@sanity/client";

export const sanityClient = createClient({
  projectId: "k728psnp",
  dataset: "production",
  apiVersion: "2023-05-03",
  useCdn: false,
});

export const fetchProducts = async (language = 'hu') => {
  const query = `*[_type == "products" && available && language == $language] {
        _id,
        name,
        description,
        price,
        language,
        category,
        sizes[] {
            ...,
            "imageURL": image.asset->url
        },
        "image": image.asset->url
    }`;

  const products = await sanityClient.fetch(query, { language });
  return products;
};
